import { Directive, Input } from '@angular/core';
import { FormControl, NG_VALIDATORS } from '@angular/forms';
import { TgValidationDirective } from '@trademe/tangram';
import { ValidatorConfig } from '@trademe/tangram/src/services/validation/validation-config';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[validation]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ValidationSchemaDirective,
            multi: true
        }
    ]
})
export class ValidationSchemaDirective extends TgValidationDirective {
    @Input() public override validation: any;

    public override validate(ctrl: FormControl) {
        for (const k in this.validation) {
            const error = (<ValidatorConfig>this.validation[k]).validator(ctrl);
            if (error != null) {
                return error;
            }
        }

        return null;
    }
}
